import React from 'react'
import {Divider, Radio} from 'antd'
import {TableViewType} from '@/constants'
import {PageSizeSelect} from '@/components/dumb/Pagination'
import {Icon} from '@/components'
import {MobileTableControlsProps} from './props'
import styles from './styles.scss'
import {RADIO_GROUP} from '@/constants/playwright-ids'

export const MobileTableControls: React.FC<MobileTableControlsProps> = (
    {setViewType, setPageSize, total, pageSize, extra}
) => {
    return <div className={styles.tableParams}>
        <Radio.Group
            className={styles.tableView}
            defaultValue={TableViewType.EXPANDED}
            onChange={setViewType}
            buttonStyle="solid"
            data-testid={RADIO_GROUP}
        >
            <Radio.Button
                key={`key-${TableViewType.EXPANDED}`}
                value={TableViewType.EXPANDED}
            >
                <Icon type={'expanded'}/>
            </Radio.Button>
            <Radio.Button
                key={`key-${TableViewType.SHORTED}`}
                value={TableViewType.SHORTED}
            >
                <Icon type={'shorted'}/>
            </Radio.Button>
        </Radio.Group>
        <div className={styles.controls}>
            <PageSizeSelect onChange={setPageSize} pageSize={pageSize} total={total}/>
            {extra && <Divider type={'vertical'}/>}
            {extra}
        </div>
    </div>
}
